import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-d560caf08c/icons/modules";

export interface LoaderProps {
  size?: keyof typeof LoaderDimensions | number;
}

export enum LoaderDimensions {
  small = 20,
  normal = 40,
  large = 80,
}

export const Loader = ({ size = LoaderDimensions.normal }: LoaderProps) => {
  const getDimension = () =>
    typeof size === "number" ? size : LoaderDimensions[size];

  return (
    <FontAwesomeIcon
      icon={byPrefixAndName.fas["spinner-third"]}
      className="fa-spin"
      data-testid="loader"
      style={{ width: getDimension(), height: getDimension() }}
    />
  );
};
